import { useNavigate } from "react-router-dom";
import { useNews } from "../../actions/homeActions";
export default () => {
  const navigate = useNavigate();
  const { data: newsList, isLoading, isError, error } = useNews();
  const handleNews = (id) => {
    navigate(`/news-details/${id}`);
  };
  const sliderSettings = {
    dots: false,
    infinite: newsList?.news?.length > 5,
    slidesToShow: newsList?.news?.length >= 5 ? 5 : newsList?.news?.length,
    slidesToScroll: 1,
    autoplay: newsList?.news?.length > 5,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    centerMode: false,
    variableWidth: false,
    className: "sm:pl-5 xl:pl-10",
    rtl: true,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow:
            newsList?.news?.length >= 2 ? 2 : newsList?.news?.length,
          cssEase: "linear",
          pauseOnHover: true,
          infinite: newsList?.news?.length > 2,
          autoplay: newsList?.news?.length > 2,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: "xs:px-3",
        },
      },
    ],
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading news: {error.message}</p>
      </div>
    );
  }
  return { isLoading, newsList, handleNews, sliderSettings };
};
